import { AsyncComponentDataStatus } from '../../state/types';
import { DailyAgendaActionFactory, DailyAgendaActions } from '../actions';
import debounce from 'lodash.debounce';
import { initAvailableDays } from '../../../../adapters/initWidgetData/initAvailableDays/initAvailableDays';

export const createOnWeekChangeAction: DailyAgendaActionFactory<
  DailyAgendaActions['onWeekChange']
> = ({ setState, flowAPI, getState }) => {
  const onWeekChangeAction: DailyAgendaActions['onWeekChange'] = async ({
    from,
    to,
  }) => {
    setState({
      availableDays: { status: AsyncComponentDataStatus.LOADING },
      selectedRange: {
        from: new Date(from),
        to: new Date(to),
      },
    });

    await initAvailableDays({ flowAPI, setState, getState });
  };
  const debouncedOnFiltersChange = debounce(async (range) => {
    await onWeekChangeAction(range);
  }, 250);

  return (range) => debouncedOnFiltersChange(range) as Promise<void>;
};
